// dashboard/frontend/src/theme.js
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      // Deep green variants
      main: '#2e7d32',      // Forest green
      light: '#4caf50',     // Regular green
      dark: '#1b5e20',      // Dark forest green
      contrastText: '#fff', // White text for contrast
    },
    secondary: {
      // Light green variants
      main: '#81c784',      // Light green
      light: '#a5d6a7',     // Very light green
      dark: '#66bb6a',      // Medium green
      contrastText: '#000', // Black text for contrast
    },
    background: {
      default: '#f9faf7',   // Very light green-tinted white
      paper: '#ffffff',     // White
    },
    text: {
      primary: '#1c2121',   // Dark green-tinted grey
      secondary: '#2e7d32',  // Forest green
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2e7d32', // Forest green for AppBar
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none', // Prevents all-caps text in buttons
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
          variant: 'outlined',
      },
      variants: [
          {
              props: { multiline: true },
              style: {
                  '& .MuiInputBase-root': {
                      transition: 'all 0.2s ease-in-out',
                  },
                  '& .MuiInputBase-inputMultiline': {
                      minHeight: '2.5em',
                      resize: 'vertical',
                      overflow: 'auto',
                      lineHeight: '1.5'
                  }
              }
          }
      ]
    },
  },
});